import React from 'react'
import aboutmevid from '../vid/aboutmevid.mp4';

export default function AboutMe() {
  const [pageLoaded, setPageLoaded] = React.useState(false);
  React.useEffect(() => {
    setPageLoaded(true);
  }, [])

  return (
    <>
      <video className='about-background h-screen w-full pb-96 fixed -translate-y-10 self-stretch' autoPlay loop muted>
        <source src={aboutmevid} type='video/mp4' />
      </video>
        <div className={"about-page bg-black grid justify-items-center mx-auto pt-12 opacity-70 ease-in duration-200 " + 
          (pageLoaded === true ? 
            'translate-x-0' :
            '-translate-x-12')
            }>

            <div className='mb-4'>
                <img src='https://avatars.githubusercontent.com/u/34861777?v=4' className='about-avatar border-green-400 border-2 rounded-full' alt='Myself standing in the snowy mountains'></img>
            </div>

            <div className='text-left mb-8 lg:w-1/2  text-white overflow-scroll'>
                <h1 className='text-4xl font-semibold p-3'>A bit about myself</h1>
                <p className='mb-3 p-3'>
                    I enjoy solving problems with computers. My main focuses are building business applications, systems for people and libraries, tooling for developers (also sometimes people).
                </p>

                <p className='mb-3 p-3'>
                    <b> 2018 </b> I started teaching myself programming. The first year was a bit of javascript and web development.
                    The syntax and basics were easy but things didnt really start to click for me until I discovered computer science.
                    I spent the next 2 years studying computer science as well as some mathematics, game theory, cryptography and web development.
                    During this time I mostly wrote c++ and javascript doing leetcode problems, small projects and a couple hackathons. All while working
                    a full time job. Fun times.
                </p>

                <p className='mb-3 p-3'>
                    <b> 2020 </b> I got into doing web development professionally working with a friend. Doing mostly ecommerce websites usually in wordpress.
                    I wrote a lot of php and javascript while creating custom themes and integrating with third party services.
                </p>

                <p className='mb-3 p-3'>
                    <b> 2023 </b> I decided to take a break from web development and started learning the Rust programming language.
                    I wanted to kind of get back to thinking about more technical problems like when I was doing computer science
                    and focus more on general software. During this time I have gotten quite into databases, compilers and systems programming.
                    Areas I didn't get as deep into in my initial studies as I would have liked. And in doing this I really rediscovered the
                    joy of programming and found my way a software engineer.
                </p>

                <p className='mb-3 p-3'>
                    I am currently building an ecosystem of business applications and api's that handle business logic and data processing
                    In all the standard ways (Appointments/Bookings/Invoicing/CRM/Emailing/Marketing/Checkouts/Inventory/CMS/ETC) which
                    can be used as standalone solutions or integrated into existing solutions and blended together. The motivation is in my
                    experience working in ecommerce. A lot of solutions which businesses reach for use lame pricing schemes and or are not designed well. I want to create
                    affordable and scalable solutions that don't have the same friction for users as I have experienced in the past..
                    <br/><br/>
                    I have also been diving deeper into databases. Experimenting with my own implementations of database engines and studying the inner workings of popular engines.
                    With the goal of soon jumping into the Turso project. Which they are rewriting sql lite in rust and making some improvements.
                </p>

                <p className='mb-3 p-3'>
                    If you read all that then <br/><br/>
                    Shoot me a message <a href="mailto:crowsecsoftware@gmail.com">email</a>
                </p>
            </div>
        </div>
    </>
  )
}
